import { render } from "./Tshaps.vue?vue&type=template&id=25ced2de&scoped=true"
import script from "./Tshaps.vue?vue&type=script&lang=js"
export * from "./Tshaps.vue?vue&type=script&lang=js"

import "./Tshaps.vue?vue&type=style&index=0&id=25ced2de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ced2de"]])

export default __exports__